export function book(){
  $(function(){
    $('.js-book_go').on('click', function(){
      $('.js-book_next').addClass('is-active');
      $('.js-book_prev').removeClass('is-active');
    })

    $('.js-book_back').on('click', function(){
      $('.js-book_prev').addClass('is-active');
      $('.js-book_next').removeClass('is-active');
    })
  });
}